import React, { createContext, useContext, useState } from "react";
import { en } from "./locales/en";
import { it } from "./locales/it";
import { de } from "./locales/de";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState("en");

  const t = {
    en,
    it,
    de
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
